import i18n from '@/locales'

const icons = {
  sync: { color: '', spin: true, can_setup: false },
  stop: { color: 'red', spin: false, can_setup: false },
  loading: { color: '', spin: true, can_setup: false },
  'plus-circle': { color: 'cadetblue', spin: false, can_setup: true },
  'check-circle': { color: 'green', spin: false, can_setup: false },
  'exclamation-circle': { color: 'red', spin: false, can_setup: false },
}

const s = function (desc, icon) {
  return { desc: i18n.t(desc), icon: icon, ...icons[icon] }
}

export const CLOUDACCOUNT_SETUP_STATUS = {
  // 1. 需要等待同步完成后才能进行下一步配置 的情况
  // 同步中
  syncing: s('status.sync.syncing', 'sync'),
  sync_status: s('status.sync.sync_status', 'sync'),
  queued: s('status.sync.queued', 'sync'),
  queuing: s('status.sync.queuing', 'sync'),
  // 2. 禁止进行下一步配置 的三种情况
  // 同步过程出错
  error: s('status.sync.error', 'stop'),
  // 同步完成,资源status异常.
  init: s('status.cloudaccount.init', 'stop'),
  disconnected: s('status.cloudaccount.disconnected', 'stop'),
  deleting: s('status.cloudaccount.deleting', 'stop'),
  deleted: s('status.cloudaccount.deleted', 'stop'),
  delete_failed: s('status.cloudaccount.delete_failed', 'stop'),
  sync_network: s('status.cloudaccount.syncing', 'stop'),
  // 健康状态异常
  insufficient: s('status.cloudaccountHealthStatus.insufficient', 'stop'),
  suspended: s('status.cloudaccountHealthStatus.suspended', 'stop'),
  arrears: s('status.cloudaccountHealthStatus.arrears', 'stop'),
  unknown: s('status.cloudaccountHealthStatus.unknown', 'stop'),
  // 资源被禁用
  disabled: s('scope.text_20', 'stop'),
  // 3. 可正常配置的状态
  // 等待配置
  pending: s('scope.setup.status.pending', 'plus-circle'),
  // 已配置
  configured: s('scope.setup.status.configured', 'check-circle'),
  // 资源配置完成状态检查中
  checking: s('scope.setup.status.checking', 'loading'),
  // 检查过程中发生错误, 抛出异常
  check_failed: s('scope.setup.status.check_failed', 'exclamation-circle'),
  // error: Not found
  cloudproviderregion_not_found: s('scope.setup.status.cloudproviderregion_not_found', 'stop'),
  cloudprovider_not_found: s('scope.setup.status.cloudprovider_not_found', 'stop'),
  // 配置项
  setup_vpc: s('scope.setup.status.setup_vpc', 'plus-circle'),
  setup_network: s('scope.setup.status.setup_network', 'plus-circle'),
}

const t = (tipKey) => {
  let infoType = 'info'
  if (['error', 'disconnected', 'deleting',
    'disabled', 'insufficient', 'suspended',
    'arrears', 'unknown'].indexOf(tipKey) >= 0) {
    infoType = 'warning'
  } else if (['check_failed', 'cloudproviderregion_not_found', 'cloudprovider_not_found'].indexOf(tipKey) >= 0) {
    infoType = 'error'
  }

  const solutions = i18n.te(`scope-setup-status-${tipKey}-tips-solutions`) ? i18n.t(`scope-setup-status-${tipKey}-tips-solutions`) : []
  return { type: infoType, desc: i18n.t(`scope.setup.status.${tipKey}.tips.desc`), solutions: solutions }
}

const CLOUDACCOUNT_SETUP_STATUS_TIPS_KEYS = [
  'sync', 'error', 'disconnected', 'init', 'deleting',
  'disabled', 'insufficient', 'suspended', 'arrears', 'unknown',
  'check_failed', 'checking', 'cloudproviderregion_not_found',
  'cloudprovider_not_found', 'setup_vpc', 'setup_network',
]

const tips = {}
CLOUDACCOUNT_SETUP_STATUS_TIPS_KEYS.map(k => { tips[k] = t(k) })

// 配置状态对应的提示信息
export const CLOUDACCOUNT_SETUP_STATUS_TIPS = tips
export const GET_CLOUDACCOUNT_SETUP_TIPS = function (status) {
  if (['syncing', 'sync_status', 'queued', 'queuing', 'sync_network'].indexOf(status) >= 0) return tips.sync
  if (['deleting', 'deleted', 'delete_failed'].indexOf(status) >= 0) return tips.deleting
  // 如果返回undefined, 则表示没有提示
  return tips[status]
}
